<template>
  <zj-layout-container>
    <zj-layout-main>
      <el-form
        :model="viewData"
        :rules="rules"
        ref="event-plan-submit"
        class="zj-search-form"
        :disabled="true"
      >
        <el-form-item label="事件名称：" style="display: inline-block">
          <el-input
            v-model="viewData.eventName"
            style="width: 23rem"
          ></el-input>
        </el-form-item>
        <el-form-item label="事件编号：" style="display: inline-block">
          <el-input v-model="viewData.eventNo" style="width: 23rem"></el-input>
        </el-form-item>
        <el-form-item label="事件级别：" style="display: inline-block">
          <el-input v-model="viewData.verifyEventLevelTranslated" style="width: 23rem"></el-input>
          <!-- <el-select v-model="viewData.verifyEventLevel" style="width: 23rem">
            <el-option
              v-for="item in EventLevelOptions"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="事件类型：" style="display: inline-block">
            <el-input v-model="viewData.verifyEventTypeTranslated" style="width: 23rem"></el-input>
          <!-- <el-select v-model="viewData.verifyEventType" style="width: 23rem">
            <el-option
              v-for="item in EventTypeOptions"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="事发地点：" style="display: inline-block">
          <el-input
            v-model="viewData.eventAddress"
            style="width: 57rem"
          ></el-input>
        </el-form-item>
        <el-form-item label="事发时间：" style="display: inline-block">
          <el-date-picker
            style="width: 23rem"
            type="datetime"
            placeholder="选择日期"
            v-model="viewData.happenTime"
            :disabled="EventInfoEdit"
            format="yyyy-MM-dd HH:mm:ss" 
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="上报人姓名：" style="display: inline-block">
          <el-input
            v-model="viewData.reportName"
            style="width: 21.5rem"
          ></el-input>
        </el-form-item>
        <el-form-item label="事件描述：" style="display: inline-block">
          <el-input
            type="textarea"
            v-model="viewData.eventDesc"
            style="width: 57rem"
          ></el-input>
        </el-form-item>
        <div style="width: 100%; height: 0; border-top: 1px solid #eee"></div>
      </el-form>
      <el-form :model="viewData" class="zj-search-form">
        <el-form-item
          label="选择预案："
          style="display: inline-block; margin-top: 2rem"
        >
          <el-select style="width: 57rem" v-model="viewData.planId">
            <el-option
              v-for="item in EventPlanOptions"
              :key="item.id"
              :label="item.planName"
              :value="item.id"
            ></el-option>
              <!-- :value="[item.id, item.planName]" -->
          </el-select>
        </el-form-item>
      </el-form>
    </zj-layout-main>
    <zj-layout-footer style="text-align: center">
      <el-button @click="onBack()">取消</el-button>
      <el-button @click="submitForm('event-plan-submit')">启动预案</el-button>
    </zj-layout-footer>
  </zj-layout-container>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";

import { getDictionary } from "@/api/src/emergency_common";
import { list } from "@/api/src/emergency_plan";
import { update } from "@/api/src/emergency_event";

import dayjs from 'dayjs'
export default {
  data() {
    return {
      EventTypeOptions: [],
      EventLevelOptions: [],
      EventPlanOptions: [],
      rules: {
        PlanId: [{ required: true, message: "请选择预案" }],
      },
      toUrl: "/plugin/Emergency/UI/EmergencyOperations",
      msgKey: "MessageKey_EmergencyPlanExecute",
    };
  },
  props: {
    viewData: Object,
  },
  watch: {
    viewData: {
    handler(newVal, oldVal) {
      this.GetPlanData();
    },
    immediate: true,
    // deep: true
  }
   
  },
  methods: {
    //取消按钮
    onBack() {
      this.$emit("cancel", {});
    },
    //确定按钮
    submitForm() {
      if (!this.viewData.planId) {
        this.errmsg("请选择预案");
        return false;
      }

      this.viewData.status = 4;
      this.viewData.startUser = ZJApp.ZJUser.current.UserName;
      this.viewData.startTime = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
      update(this.viewData)
        .then((r) => {
          r = r.data;
          console.log(r);
          //todo启动应急
          if (r) {
                var msgcontent = {
                  key: this.msgKey,
                  data: this.viewData.id,
                };
                this.$notify.broadcase(msgcontent);
                this.$router.push({
                  path: this.toUrl,
                  query: {
                    ExecutId: this.viewData.id,
                  },
                });
            // this.$emit("search", {});
            // this.$emit("ok", {});
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    GetPlanData() {
      let searchInfo = {
        size: 10000,
        current:1,
        applicableEvent: this.viewData.verifyEventType,
        planStatus: 1
      };
      this.loading = true;
      this.loadingText = '加载中...';
      list(searchInfo)
        .then(r => {
          r = r.data;
          this.EventPlanOptions = r.records;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
  },
  created: function () {
    // getDictionary('emergency_event_level')
    //   .then((eventtypeconf) => {
    //     this.EventTypeOptions = eventtypeconf.data.records;
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });

    // getDictionary('emergency_event_type')
    //   .then((eventlevelconf) => {
    //     this.EventLevelOptions = eventlevelconf.data.records;
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
    // this.GetPlanData();
  },
};
</script>
